import { Button } from "@/components/ui/button";
import useScrollDirection from "@/hooks/useScrollDirection";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import HeadingText from "./HeadingText";

interface HeadingProps {
  categoryCount: number;
  questionCount: number;
  isLoading?: boolean;
}

function Heading({ isLoading, categoryCount, questionCount }: HeadingProps) {
  const { t } = useTranslation();
  const scrollDirection = useScrollDirection();
  return (
    <div
      className={twMerge(
        scrollDirection === "up" && "top-16",
        scrollDirection === "down" && "top-[-120px]",
        "sticky z-10 flex items-start justify-between gap-2 border-b bg-white px-4 py-5 pt-8 transition-all md:px-16",
      )}
    >
      <HeadingText
        categoryCount={categoryCount}
        questionCount={questionCount}
      />
      <Button isLoading={isLoading} type="submit">
        {t("submit-free-assessment")}
      </Button>
    </div>
  );
}

export default Heading;
